export const GLOBAL_TSR = '$_TSR'
export declare const GLOBAL_SEROVAL: '$R'
